// extracted by mini-css-extract-plugin
module.exports = {"default":"item-module__default___su3hr","theme_gray":"item-module__theme_gray___IbCJT"};